var icon = require('vue-svgicon')
icon.register({
  'ks-icon-hash': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M33.32 105.9l3.3-18.62H18L19.63 78h18.62l4.94-28H24.56l1.63-9.31h18.63l3.3-18.62h9.32l-3.31 18.65h27.93l3.31-18.62h9.31l-3.3 18.62H110L108.37 50H89.75l-4.94 28h18.63l-1.63 9.31H83.18l-3.3 18.62h-9.32l3.31-18.62H45.94l-3.31 18.59h-9.31M52.5 50l-4.94 28H75.5l4.94-28z"/>'
  }
})
